export default [
    {
        path:'/RootPage',
        name:'RootPage',
        component:() => import('./RootPage.vue'),
    },
    {
        path:'/RolePage',
        name:'RolePage',
        component:() => import('../RolePage/RolePage.vue'),
    },
    {
        path:'/AddJurisdiction',
        name:'AddJurisdiction',
        component:() => import('./AddJurisdiction.vue'),
    },
]